export default __webpack_public_path__ + "static/am-blog-73ad5adebbd19f5f656d6f62101bf526.jpg";